import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import Auditee from "./Auditee";
import { getDropDownVal } from "../dropdownUtils.js";
import CustomLoader from "../static/CustomLoader.js";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const AuditeeListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");

  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [loading, setLoading] = useState(false);
  const [auditees, setAuditees] = useState([]);
  const [divData, setDivData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [licenseStatus, setLicenseStatus] = useState([]);
  const [hazardCategoryOptions, setHazardCategoryOptions] = useState([]);
  const [empTypeData, setEmpTypeData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectorData, setSectorData] = useState([]);
  const [workingData, setWorkingData] = useState([]);
  const [ownshirpData, setOwnshirpData] = useState([]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [density, setDensity] = useState("standard");
  const [showConfirm, setShowConfirm] = useState(false);
  const [addShow, setAddShow] = useState(false);
  const [editShow, setEditShow] = useState(false);

  const columns = [
    {
      field: "divcode",
      headerName: "Division",
      width: 220,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const divOption = divData.find(
          (option) => option.value === params.value,
        );

        return divOption ? divOption.label : params.value;
      },
    },
    {
      field: "licencenumber",
      headerName: "Licence Number",
      width: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 180,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "primaryphone",
      headerName: "Phone",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      width: 220,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "addressline",
      headerName: "Address",
      flex: 1,
      minWidth: 220,
      headerAlign: "center",
      align: "center",
    },
  ];

  const fetchDepartments = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${apiUrl}division`, { headers });

      const data = response.data;

      if (data.cd === 1) {
        toast.error(data.description || "Failed to fetch Acess");
        setDivData([]);
      } else {
        const sectionOption = data.map((op) => ({
          value: op.code,
          label: op.name,
        }));

        setDivData(sectionOption);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchUser = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${apiUrl}user`, { headers });

      const data = response.data;

      if (data.cd === 1) {
        toast.error(data.description || "Failed to fetch User");
        setUserData([]);
      } else {
        const sectionOption = data.map((op) => ({
          value: op.empcode,
          label: op.userid,
        }));

        setUserData(sectionOption);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(apiUrl + "auditee", { headers });

      setAuditees(response.data);
      setFilterData(response.data);
      setRefresh(false);
      setSelectedData([]);
    } catch (error) {
      console.log("error " + error);
      setAuditees([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDepartments();
    fetchUser();
  }, [refresh]);

  useEffect(() => {
    const fetchEmployeeTypeOptions = () => {
      try {
        const response = getDropDownVal("EMPTP");

        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));

        setEmpTypeData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchOwnShirpOptions = () => {
      try {
        const response = getDropDownVal("OWN");

        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));

        setOwnshirpData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchWorkingOptions = () => {
      try {
        const response = getDropDownVal("FWST");

        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));

        setWorkingData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchSectorOptions = () => {
      try {
        const response = getDropDownVal("SST");

        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));

        setSectorData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchSectionOptions = () => {
      try {
        const response = getDropDownVal("SCT");

        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));

        setSectionData(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchLicenceStatusOptions = () => {
      try {
        const response = getDropDownVal("LRST");

        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));

        setLicenseStatus(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    const fetchHazardCategoryOptions = () => {
      try {
        const response = getDropDownVal("HCAT");

        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));

        setHazardCategoryOptions(actOption);
      } catch (error) {
        console.log("error");
      }
    };

    fetchEmployeeTypeOptions();
    fetchOwnShirpOptions();
    fetchWorkingOptions();
    fetchSectorOptions();
    fetchSectionOptions();
    fetchLicenceStatusOptions();
    fetchHazardCategoryOptions();
  }, []);

  const handlesearch = (event) => {
    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );

      setAuditees(searchdata);
    } else {
      setAuditees(filterData);
    }

    setSerach(getSearch);
  };

  const addHandleShow = () => {
    setAddShow(true);
  };

  const addHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }

    setEditShow(true);
  };

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setAddShow(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const RemoveFunction = async () => {
    if (selectedData) {
      swal({
        title: "Do you want to remove?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (confirmDelete) => {
        if (confirmDelete) {
          setLoading(true);

          try {
            await axios.delete(apiUrl + "auditee/" + selectedData[0], {
              headers,
            });

            toast.success("Record removed successfully.");

            fetchData();
          } catch (error) {
            console.error("Error deleting record:", error);
          } finally {
            setLoading(false);
          }
        }
      });
    } else {
      toast.warning("Please Select at least one value");
      setLoading(false);
    }
  };

  const handleExport = () => {
    if (!auditees || auditees.length === 0) {
      toast.warning("No data to export.");
      return;
    }

    const exportData = auditees.map((item) => {
      let industry = {};

      try {
        industry = JSON.parse(item.industry || "{}");
      } catch (e) {
        console.warn("Invalid industry JSON:", e);
      }

      return {
        id: item.id,
        code: item.code,
        divcode: item.divcode,
        licencenumber: item.licencenumber,
        name: item.name,
        description: item.description,
        primaryphone: item.primaryphone,
        email: item.email,
        addressline: item.addressline,
        city: item.city,
        dist: item.dist,
        state: item.state,
        country: item.country,
        pincode: item.pincode,
        latd: item.latd,
        longt: item.longt,
        amendment: item.amendment,
        user: item.user,
        ...industry,
      };
    });

    const ws = XLSX.utils.json_to_sheet(exportData);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Auditees");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(file, `auditees_export_${Date.now()}.xlsx`);
  };

  const handleImport = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (evt) => {
      const data = evt.target.result;

      const workbook = XLSX.read(data, {
        type: "binary",
      });

      const sheetName = workbook.SheetNames[0];

      const sheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(sheet);

      if (!jsonData || jsonData.length === 0) {
        toast.warning("No data found in the file to import.");
        return;
      }

      const formattedPayload = jsonData.map((row) => {
        const formData = {
          divisionCode:
            row.divisionCode !== undefined && row.divisionCode !== null
              ? parseInt(row.divisionCode)
              : 0,
          districtCode: row.districtCode ?? "",
          talukCode: row.talukCode ?? "",
          factoryRegDate: row.factoryRegDate ?? "",
          nicCode: row.nicCode ?? "",
          natureOfManufacturing: row.natureOfManufacturing ?? "",
          horsePower:
            row.horsePower !== undefined && row.horsePower !== null
              ? row.horsePower
              : 0,
          kilowatt:
            row.kilowatt !== undefined && row.kilowatt !== null
              ? row.kilowatt
              : 0,
          fees: row.fees !== undefined && row.fees !== null ? row.fees : 0,
          licenseRenewalStatus: row.licenseRenewalStatus ?? "",
          licenseStrength:
            row.licenseStrength !== undefined && row.licenseStrength !== null
              ? row.licenseStrength
              : 0,
          hazardCategory: row.hazardCategory ?? "",
          coveredUnderSection: row.coveredUnderSection ?? "",
          sector: row.sector ?? "",
          workingStatus: row.workingStatus ?? "",
          ownership: row.ownership ?? "",
          occupierEmail: row.occupierEmail ?? "",
          occupierPhone: row.occupierPhone ?? "",
          occupierAddress: row.occupierAddress ?? "",
          managerEmail: row.managerEmail ?? "",
          managerPhone: row.managerPhone ?? "",
          managerAddress: row.managerAddress ?? "",
          managername: row.managername ?? "",
          occupiername: row.occupiername ?? "",
        };

        return {
          id: 0,
          code: 0,
          divcode:
            row.divcode !== undefined && row.divcode !== null
              ? parseInt(row.divcode)
              : 0,
          licencenumber: row.licencenumber ?? "",
          name: row.name ?? "",
          description: row.description ?? "",
          primaryphone:
            row.primaryphone !== undefined && row.primaryphone !== null
              ? parseInt(row.primaryphone)
              : 0,
          email: row.email ?? "",
          addressline: row.addressline ?? "",
          city: row.city ?? "",
          dist: row.dist ?? "",
          state: row.state ?? "",
          country: row.country ?? "",
          pincode:
            row.pincode !== undefined && row.pincode !== null
              ? parseInt(row.pincode)
              : 0,
          latd:
            row.latd !== undefined && row.latd !== null
              ? parseFloat(row.latd)
              : 0,
          longt:
            row.longt !== undefined && row.longt !== null
              ? parseFloat(row.longt)
              : 0,
          industry: JSON.stringify(formData),
          occupier: row.occupier ?? "[]",
          manager: row.manager ?? "[]",
          employee: row.employee ?? "[]",
          amendment: row.amendment ?? "",
          user:
            row.user !== undefined && row.user !== null
              ? parseInt(row.user)
              : 0,
        };
      });

      const confirm = window.confirm(
        `You are about to import ${formattedPayload.length} record(s). Do you want to proceed?`,
      );

      if (!confirm) {
        toast.info("Import cancelled.");
        return;
      }

      try {
        setLoading(true);

        const resp = await axios.post(
          `${apiUrl}auditee/multipleSave`,
          formattedPayload,
          { headers },
        );

        if (resp.data.cd === 1) {
          toast.error(resp.data.description || "Import failed");
        } else {
          toast.success("Import successful!");
        }
      } catch (error) {
        console.error("Import failed", error);
        toast.error("Import failed");
      } finally {
        setLoading(false);
        fetchData();
      }
    };

    reader.readAsBinaryString(file);
    e.target.value = null;
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <>
              <MasterButton
                variant="add"
                tooltip="Create new Auditee"
                onClick={addHandleShow}
                disabled={loading}
              >
                Add
              </MasterButton>

              <MasterButton
                variant="update"
                tooltip="Edit Selected Auditee"
                onClick={editHandleShow}
                disabled={loading}
              >
                Update
              </MasterButton>

              <MasterButton
                variant="danger"
                tooltip="Delete Selected Auditee"
                onClick={RemoveFunction}
                disabled={loading}
              >
                Delete
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Export Auditee data to Excel"
                onClick={handleExport}
                disabled={loading}
              >
                Export
              </MasterButton>

              <MasterButton
                variant="outline"
                tooltip="Import Auditee data"
                component="label"
                icon={<UploadFileOutlinedIcon />}
                disabled={loading}
              >
                Import Data
                <input
                  type="file"
                  accept=".csv"
                  hidden
                  onChange={handleImport}
                />
              </MasterButton>
            </>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            auditees !== null &&
            auditees.length > 0 &&
            Object.keys(auditees[0]).length !== 0 &&
            auditees
          }
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      {loading && <CustomLoader />}

      <MasterDialog
        open={addShow}
        onHide={addHandleClose}
        title="Add Auditee"
        maxWidth="lg"
      >
        <Auditee
          selectedId=""
          mode="A"
          onHide={addHandleClose}
          setRefresh={setRefresh}
          divData={divData}
          userData={userData}
          employeeTypeOptions={empTypeData}
          licenseRenewalData={licenseStatus}
          hazardCategoryData={hazardCategoryOptions}
          sectionData={sectionData}
          sectorData={sectorData}
          workingData={workingData}
          ownshirpData={ownshirpData}
        />
      </MasterDialog>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Auditee"
        maxWidth="lg"
      >
        <Auditee
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          divData={divData}
          userData={userData}
          employeeTypeOptions={empTypeData}
          licenseRenewalData={licenseStatus}
          hazardCategoryData={hazardCategoryOptions}
          sectionData={sectionData}
          sectorData={sectorData}
          workingData={workingData}
          ownshirpData={ownshirpData}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default AuditeeListing;
